import { render, staticRenderFns } from "./MainProduct.vue?vue&type=template&id=694bd709&scoped=true&"
import script from "./MainProduct.vue?vue&type=script&lang=js&"
export * from "./MainProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694bd709",
  null
  
)

export default component.exports